import navigationMenuData from './navigationMenuData.json';
import tablist from './tablistData.json';
import banners from './bannerIndexData.json';
import sections from './sectionsData.json';
import clients from './logoClientsData.json';
import footer from './footerData.json';
import stickerLink from './stickerLinkData.json';
import statistics from './statisticsData.json';
import cookiesData from './cookiesData.json';
import cardItemData from './cardItemData.json';
import greatPlaceToWorkData from './greatPlaceToWorkData.json';
import bannerInternship from './bannerInternship.json';

export default {
  sectionName: 'homepage',
  navigationMenuData,
  tablist,
  stickerLink,
  banners: banners.bannerIndexData,
  sections,
  mediaCarousel: clients,
  footer,
  statistics,
  cookiesData,
  cardItemData,
  greatPlaceToWorkData,
  bannerInternship,
};
